import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthCallbackComponent } from './auth-callback.component';

@NgModule({
    declarations: [AuthCallbackComponent],
    imports: [CommonModule],
    exports: [AuthCallbackComponent],
    providers: [],
})
export class AuthCallbackModule {}
